<template>
  <BaseModal
    ref="baseModal"
    :onCloseHook="onCloseHook"
    :onOpenHook="onOpenHook"
    minHeight="553px"
    hook-sufix="EditKeysModal"
    modalTransition="slide-x-transition"
  >
    <template #content>
      <div
        class="text-h6"
        style="position: absolute; top: 0; padding-top: 33px"
      >
        <v-btn color="primary" icon @click="closeMyModal">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span style="font-weight: 500">
          {{ $t('message.pages.live.changeKey') }}</span
        >
      </div>

      <p class="mb-7">
        {{ $t('message.pages.live.changeKeyDescription') }}
      </p>

      <label class="page-label"> {{ $t('message.pages.live.keyName') }} </label>

      <v-form v-model="valid">
        <v-text-field
          style="max-width: 82%"
          v-model="keyName"
          dense
          :placeholder="$t('message.pages.newLive.keyName')"
          :rules="[rules.required, rules.maxLength, rules.minLength]"
          outlined
        />
      </v-form>

      <label class="page-label">{{ $t('message.pages.live.key') }}</label>
      <div class="d-flex align-center">
        <v-text-field
          v-model="keyStreamKey"
          :type="showKey ? 'text' : 'password'"
          class="mr-5 mb-3"
          outlined
          dense
          hide-details
          readonly
          style="max-width: 82%"
        >
          <template v-slot:append>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="mr-3" @click="toggleShowKey">{{
                  showKey ? 'mdi-eye' : 'mdi-eye-off'
                }}</v-icon>

                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  @click="handleShowLink(keyStreamKey)"
                >
                  mdi-content-copy
                </v-icon>
              </template>
              <span>{{
                $t('message.pages.videoEditModal.copyToClipboard')
              }}</span>
            </v-tooltip>
          </template>
        </v-text-field>
        <div
          class="reset-key"
          @click="!isLoading && resetKey()"
          style="padding-bottom: 10px"
        >
          <v-icon v-if="!isLoading" class="mr-2" color="primary">
            mdi-refresh
          </v-icon>
          <v-icon v-else class="mr-2" color="primary">
            mdi-loading mdi-spin
          </v-icon>
          <span
            v-if="!isLoading"
            style="color: var(--v-brand-base); font-weight: 500"
          >
          {{ $t('message.pages.live.resetKey') }}
          </span>
        </div>
      </div>
      <!-- check -->
      <v-checkbox
        v-model="checkbox"
        :label="$t('message.pages.live.patternKey')"
        class="py-0 my-0 mt-5"
        hide-details
      />
    </template>

    <!-- actions -->
    <template #card-actions>
      <v-btn icon @click="deleteKey">
        <v-icon color="red">mdi-delete</v-icon>
      </v-btn>

      <v-card-actions class="pt-15 pb-9 px-0 d-flex">
        <!-- buy -->
        <base-btn
          :loading="isLoading"
          :disabled="form.title || isLoading || !valid"
          class="ml-auto"
          type="primary"
          @click="saveEdit"
        >
          {{ $t('message.pages.newLive.save') }}
        </base-btn>
      </v-card-actions>
    </template>
  </BaseModal>
</template>

<script>
// external imports
import { mapMutations } from 'vuex'

// internal imports

import i18n from '@/translations/lang'

// API
import liveStreamKeyApi from '@/services/liveStreamKeyApi'

// Components

export default {
  name: 'KeysModal',
  components: {
    BaseModal: () => import('@/components/BaseModal.vue'),
    BaseBtn: () => import('@/components/BaseBtn.vue'),
  },
  data: () => ({
    selectedKey: null,
    attrs: {},
    on: {},
    isKeyDefault: false,
    valid: false,
    keyName: null,
    keyStreamKey: null,
    keyId: null,
    showKey: false,
    isEditing: false,
    isLoading: false,
    form: {
      title: '',
      selected: null,
      showKeyIndex: null,
    },
    rules: {
      required: (v) => (v && !!v) || i18n.t('message.requiredField'),
      maxLength: (v) =>
        (v && v.length <= 11) || i18n.t('message.maximumLength'),
      minLength: (v) => (v && v.length > 2) || i18n.t('message.minimumLength'),
    },
    checkbox: false,
    checkboxStorageKey: 'globalBaseModalMessageCheckbox',
    list: {
      keys: [],
    },
  }),
  created() {
    this.$root.$on('openEditKeysModal', (keyId, keyName, keyStreamKey) => {
      this.keyName = keyName.toString()
      this.keyId = keyId.toString()
      this.keyStreamKey = keyStreamKey.toString()
    })
  },
  computed: {
    // ...
  },
  watch: {
    isEditing() {
      this.form.title = ''
      ;(this.form.selected = null), (this.form.showKeyIndex = null)
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    handleShowLink(value) {
      const i18n = this.$i18next
      let text = 'Error trying coping this. Please coping directly from field'

      if (navigator && navigator.clipboard) {
        text = i18n.t('message.copiedToClipboard')
        navigator.clipboard.writeText(`${value}`)
      }

      this.UPDATE_GLOBAL_SNACKBAR({ open: true, text })
    },

    handleShowKey({ e, index }) {
      if (e) {
        e.preventDefault()
        e.stopPropagation()
      }

      if (this.form.showKeyIndex === null) this.form.showKeyIndex = index
      else this.form.showKeyIndex = null
    },
    handleRowClick({ e, index }) {
      if (e) {
        e.preventDefault()
        e.stopPropagation()
      }

      if (this.isEditing) return

      if (this.form.selected === null) this.form.selected = index
      else this.form.selected = null
    },

    async deleteKey() {
      try {
        const response = await liveStreamKeyApi.deleteLiveStreamKey({
          id: this.keyId,
        })
        if (response && response.status === 200) {
          await this.loadData()
          this.$emit('keyDeleted')
          this.onCloseHook()
        }
      } catch (error) {
        console.error('Erro ao excluir a chave:', error)
      }
    },

    async resetKey() {
      this.isLoading = true
      try {
        const deleteResponse = await liveStreamKeyApi.deleteLiveStreamKey({
          id: this.keyId,
        })
        if (deleteResponse && deleteResponse.status === 200) {
          const createResponse = await liveStreamKeyApi.createLiveStreamKey({
            title: this.keyName,
          })
          if (createResponse && createResponse.status === 200) {
            this.keyStreamKey = createResponse.data.stream_key
            this.keyId = createResponse.data.id
          }
        }
      } catch (error) {
        console.error('Erro ao resetar a chave:', error)
      } finally {
        this.isLoading = false
      }
    },
    async updateKeyDefault() {
      this.isLoading = true
      const keyIdToUpdate = this.keyId

      try {
        const dataToUpdate = {
          title: this.keyName,
          set_default: true,
        }

        const response = await liveStreamKeyApi.saveLiveStreamKey({
          id: keyIdToUpdate,
          data: dataToUpdate,
        })

        if (response && response.status === 200) {
          await this.loadData()
        }

        this.isLoading = false
      } catch (error) {
        console.error('e', error)
      }
    },

    async onOpenHook() {
      await this.loadData()

      const selectedKey = this.list.keys.find((key) => key.id === this.keyId)
      if (selectedKey) {
        this.checkbox = selectedKey.default
      }
    },

    onCloseHook() {
      this.openModal()
      this.isEditing = false
    },

    async saveNewKey() {
      const newKeyName = this.keyName
      this.isLoading = true
      try {
        const dataToCreate = {
          title: newKeyName,
        }
        const response = await liveStreamKeyApi.createLiveStreamKey(
          dataToCreate
        )
        if (response && response.status === 200) this.isLoading = false
      } catch (error) {
        this.showNoticeError = true
        console.error('e', error)
        this.isLoading = false
      }
    },
    openModal() {
      this.$root.$emit('openKeysModal')
    },
    handleSelectedStreamKey(selectedKey) {
      this.selectedKey = selectedKey
      this.$emit('selected-live-stream-key', selectedKey)
      this.isSelected = true
    },
    toggleShowKey() {
      this.showKey = !this.showKey
    },
    closeMyModal() {
      this.$refs.baseModal.handleClose()
    },
    async saveEdit() {
      this.isLoading = true
      const updatedKeyName = this.keyName
      const keyIdToUpdate = this.keyId

      try {
        const dataToUpdate = {
          title: updatedKeyName,
        }

        const response = await liveStreamKeyApi.saveLiveStreamKey({
          id: keyIdToUpdate,
          data: dataToUpdate,
        })
        if (response && response.status === 200 && this.checkbox === true) {
          await this.loadData()
          await this.updateKeyDefault()
          this.$emit('keyUpdated')
          this.closeMyModal()
        }
        if (response && response.status === 200 && this.checkbox === false) {
          await this.loadData()
          this.$emit('keyUpdated')
          this.closeMyModal()
        }
        this.isLoading = false
        this.onCloseHook()
      } catch (error) {
        console.error('e', error)
      }
    },
    goPlan() {
      this.onCloseHook()
      this.$router.push({ name: 'Cart' })
    },
    selectKey() {
      this.onCloseHook()

      const selectedKeyId = this.list.keys[this.form.selected].id
      const selectedKey = this.list.keys.find((key) => key.id === selectedKeyId)

      if (selectedKey) {
        selectedKey.is_online = true
        this.$emit('selected-live-stream-key', selectedKeyId)
      }

      this.$root.$emit('closeLiveKeysModal')
    },

    async loadData() {
      try {
        const { data } = await liveStreamKeyApi.getAllLiveStreamKey()
        this.list.keys = []
        for (const item of data) {
          this.list.keys.push(item)
        }
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/table';

::v-deep {
  @import '@/assets/scss/src/new-live';

  .v-text-field fieldset,
  .v-text-field .v-input__control {
    border-color: var(--v-neutral-lighten2);
    color: var(--v-neutral-base);
  }

  .is-clickable {
    cursor: pointer;
  }

  .reset-key:hover {
    cursor: pointer;
  }

  .chip {
    padding: 2px 8px 2px 8px;
    border-radius: 30px;

    justify-content: center;
    align-items: center;

    font: {
      family: Rubik;
      size: 14px;
      style: normal;
      height: 150%;
    }

    &.is-in-use {
      color: var(--v-brand-base);
      background: var(--v-neutral-lighten3);
    }

    &.is-free {
      color: #1b5e20;
      background: #c8e6c9;
    }
  }
}

.page-label {
  font-size: 16px !important;
  color: var(--v-neutral-lighten1) !important;
  font-weight: 500p !important;
  line-height: 21px !important;
}
</style>
